import * as React from "react"
import { cn } from "../../lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-lg border border-[#2F7F571A] bg-[#F6F8F7] px-3 py-2 text-sm text-primary ring-offset-white placeholder:text-[#6B7280] font-sans focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2F7F57] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
